import { to_dark } from "@/utils/colorcode";
import { Button } from "@mui/material";
import React from "react";

interface SubmitButtonProps {
  label: string;
  fullWidth?: boolean;
  disabled?: boolean;
  color?: string;
  onClick?: () => void;
}

export const SubmitButton: React.FC<SubmitButtonProps> = (props) => {
  return (
    <Button
      type="submit"
      disableElevation
      variant="contained"
      fullWidth
      sx={{
        height: 56,
        fontSize: 15,
        fontWeight: "bold",
        backgroundColor: props.color ? props.color : "primary",
        borderColor: props.color ? props.color : "primary",
        "&:hover": {
          backgroundColor: props.color ? to_dark(props.color) : "primary",
          borderColor: props.color ? to_dark(props.color) : "primary",
          boxShadow: "none",
        },
      }}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      <>{props.label}</>
    </Button>
  );
};
